module.exports = "<iframe\n    width=\"<%=width%>\"\n    height=\"<%=height%>\"\n    src=\"<%=src%>\"\n    frameborder=\"0\"\n    class=\"<%=className%>\"\n    style=\"<%=inlineStyle%>\">\n</iframe>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/fabric-expanding-video.html
// module id = 583
// module chunks = 1